import { StyleSheet } from '@react-pdf/renderer';

/** Default bullet dot size in pt */
const BULLET_DOT_SIZE = 4;

const styles = StyleSheet.create({
  p: { marginBottom: 8 },
  strong: { fontWeight: 600 },
  em: { fontStyle: 'italic' },
  u: { textDecoration: 'underline' },
  ul: { marginBottom: 8 },
  ol: { marginBottom: 8 },
  li: { marginBottom: 3 },
  bulletLi: { marginBottom: 3 },

  // View-based bullet row for unordered list items
  bulletRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 3,
  },

  bulletDot: {
    width: BULLET_DOT_SIZE,
    height: BULLET_DOT_SIZE,
    borderRadius: BULLET_DOT_SIZE / 2,
    backgroundColor: '#333333',
    marginTop: 5,
    marginRight: 6,
  },

  bulletContent: {
    flex: 1,
  },

  // Ordered list item with number prefix
  numberedLi: { marginBottom: 3 },

  h1: { fontSize: 16, fontWeight: 600, marginBottom: 8 },
  h2: { fontSize: 14, fontWeight: 600, marginBottom: 8 },
  h3: { fontSize: 12, fontWeight: 600, marginBottom: 6 },
  a: { color: '#2563eb', textDecoration: 'underline' },
  blockquote: {
    borderLeftWidth: 2,
    borderLeftColor: '#9ca3af',
    paddingLeft: 10,
    marginVertical: 8,
    fontStyle: 'italic',
    color: '#4b5563',
  },
  pre: {
    backgroundColor: '#f3f4f6',
    padding: 8,
    borderRadius: 4,
    marginVertical: 8,
    fontFamily: 'Courier',
  },
  code: {
    fontFamily: 'Courier',
    fontSize: 8,
  },
});

export default styles;
